<template>
  <div class="p-15">
    <el-card>
      <el-form ref="ruleForm" :model="searchForm" inline>
        <el-form-item prop="query.title">
          <el-input v-model="searchForm.query.title" placeholder="请输入专题名称"></el-input>
        </el-form-item>
        <el-form-item prop="query.status">
          <status-option v-model="searchForm.query.status"></status-option>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetPagination" type="primary">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
        <el-form-item class="fr">
          <router-link :to="{ name: 'settings-special-page-add' }">
            <el-button type="primary">新增专题页面</el-button>
          </router-link>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="m-t-20">
      <el-table :data="tableData">
        <el-table-column label="专题名称" prop="title"></el-table-column>
        <el-table-column label="封面">
          <template slot-scope="{ row }">
            <el-image :src="row.coverImage" :preview-src-list="srcList" style="width: 50px; height: 50px"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="场景值" width="400">
          <template slot-scope="{ row }">
            <el-input v-model="row.scene" @blur="onBlurScene(row)" placeholder="请输入场景值" style="width: 200px" />
          </template>
        </el-table-column>
        <el-table-column label="UV/PV" width="100">
          <template slot-scope="{ row }">{{ row.uv }}/{{ row.pv }}</template>
        </el-table-column>

        <el-table-column label="活动时间" width="400">
          <template slot-scope="{ row }">{{ row.startTime }}~{{ row.endTime }}</template>
        </el-table-column>
        <el-table-column label="页面状态" width="150">
          <template slot-scope="{ row }">
            {{ STATUS_DESC(row.status) }}
          </template>
        </el-table-column>
        <el-table-column label="是否展示" width="150">
          <template slot-scope="{ row }">
            <el-switch @change="val => changeOnshow(val, row)" v-model="row.onShow"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="{ row }">
            <el-link @click="onCopy(`/subPackages/special-page/home?id=${row.id}&scene=${row.scene}`)" type="primary">链接</el-link>
            <router-link :to="{ name: 'settings-special-page-edit', query: { id: row.id } }">
              <el-link v-if="row.status !== ENDED" type="primary">编辑</el-link>
            </router-link>
            <el-link v-if="row.status === UN_START" @click="handleDel(row)" type="danger">删除</el-link>
            <router-link :to="{ name: 'settings-special-page-view', query: { id: row.id } }">
              <el-link v-if="row.status === ENDED" type="primary">查看</el-link>
            </router-link>
            <el-link @click="getCode(row)" type="primary">小程序码</el-link>
          </template>
        </el-table-column>
      </el-table>
      <pagination :changed="changePage" :total="total" :pagination="searchForm.pagination" />
      <download-img :visible="visible" :url="url" :name="name" @downed="visible = false"></download-img>
    </el-card>
  </div>
</template>

<script>
import statusOption from '@/views/Interaction/components/status-option'
import { delSpecialPage, getSpecialPageList, updateSpecialPage } from '@/api/special-page'
import { ENDED, NORMAL, STATUS_DESC, UN_START } from '@/enums/register'
import { createMiniCode } from '@/api/music'

export default {
  name: 'special-page',
  components: {
    statusOption
  },
  computed: {
    srcList() {
      return this.tableData.map(item => item.coverImage)
    }
  },
  data() {
    return {
      searchForm: {
        query: {
          title: undefined,
          status: undefined
        },
        pagination: {
          currentPage: 1,
          limit: 10
        }
      },
      tableData: [],
      total: 0,

      STATUS_DESC,
      NORMAL,
      UN_START,
      ENDED,

      visible: false,
      url: undefined,
      name: undefined
    }
  },
  methods: {
    resetPagination() {
      this.searchForm.pagination = { currentPage: 1, limit: 10 }
      this.init()
    },
    async getCode(row = undefined) {
      if (!row.wxaCodeUrl) {
        const loading = this.$loading({
          text: '生成中...'
        })
        try {
          row.wxaCodeUrl = await createMiniCode({ id: row.id, type: 'special_page' })
        } finally {
          loading.close()
        }
      }
      this.url = row.wxaCodeUrl
      this.name = row.title
      this.visible = true
    },
    async changeOnshow(val, row) {
      await updateSpecialPage(row.id, { onShow: val })
      await this.init()
      this.$message.success('操作成功')
    },
    async handleDel(row) {
      await this.$confirm('确定删除此专题配置吗？')
      await delSpecialPage(row.id)
      await this.init()
      this.$message.success('操作成功')
    },
    reset() {
      this.$refs.ruleForm.resetFields()
      this.init()
    },
    changePage(page) {
      this.searchForm = Object.assign(this.searchForm, page)
      this.init()
    },
    async init() {
      const { collection, meta } = await getSpecialPageList(this.searchForm)
      this.tableData = collection
      this.total = meta.total
    },
    async onBlurScene(row) {
      await updateSpecialPage(row.id, { scene: row.scene })
      this.$message.success(`${row.title}的场景值修改成功`)
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped></style>
